<script setup lang="ts">
defineOptions({
  name: 'TutorLegalRows',
})
</script>

<template>
  <div class="tutor-legal-rows">
    <slot />
  </div>
</template>

<style lang="scss" scoped src="./TutorLegalRows.scss" />
